export const frag = /*glsl*/ `
precision mediump float;

uniform vec3 uColor;
uniform float uTime;
uniform sampler2D tNoise;

varying vec3 vNormal;
varying vec2 vUv;

#define PI 3.141592

float pow2(float x) {
	return x * x;
}
vec3 czm_saturation(vec3 rgb, float adjustment)
{
    return mix(vec3(dot(rgb, vec3(0.2125, 0.7154, 0.0721))), rgb, adjustment);
}
vec3 hueShift(vec3 color, float hue) {
    vec3 k = vec3(0.57735, 0.57735, 0.57735);
    float cosAngle = cos(hue);
    return vec3(color * cosAngle + cross(k, color) * sin(hue) + k * dot(k, color) * (1.0 - cosAngle));
}

void main(){
	float noise = texture2D(tNoise, vec2(sin(vUv.x * PI + uTime * .0002) * .05), vUv.y * .1).r + texture2D(tNoise, vec2(sin(vUv.x * PI - uTime * .00015) * .05), vUv.y * .2).r;
	noise += smoothstep(.8, .5, vUv.y) * smoothstep(.45, .55, vUv.y);
	noise *= smoothstep(0., .2, vUv.x) * smoothstep(1., .8, vUv.x);
	noise *= smoothstep(.4, .5, vUv.y) * .5 + .5;
	noise *= .5 + sin(uTime * .002) * .1;

	float intensity = pow2(noise) * pow2(smoothstep(.4 + sin(uTime * .0015) * .1, 0., abs(vUv.y - .5)) * smoothstep(-.2, .1, abs(vUv.y - .5)));
	vec3 color = intensity * uColor * .2;
	color *= smoothstep(2.8, 2., abs(vNormal.x));
	color *= smoothstep(.5, 2., abs(vNormal.x)) * .8 + .2;

	color = czm_saturation(color, 1. + intensity * .1);// + pow2(intensity) * .1;
	color = hueShift(color, intensity * .2);

	gl_FragColor = vec4(color, 1.);
}`;
